module.exports = __webpack_public_path__ + "images/emoji/nine.2eb1fb871f6f6df54a8f.png";